import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=cb0f0ad2"
import script from "./PolicyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPage.vue?vue&type=script&lang=js"
import style0 from "./PolicyPage.vue?vue&type=style&index=0&id=cb0f0ad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports